import type { SvgProps } from "replo-utils/react/components";

import * as React from "react";

import { Svg } from "replo-utils/react/components";

const Page = (props: SvgProps) => (
  <Svg width={22} height={22} viewBox="0 0 22 22" fill="none" {...props}>
    <g filter="url(#filter0_iin_1097_19232)">
      <path
        d="M18.3335 3.66675H3.66683C3.31321 3.66675 2.97407 3.80722 2.72402 4.05727C2.47397 4.30732 2.3335 4.64646 2.3335 5.00008V17.0001C2.3335 17.3537 2.47397 17.6928 2.72402 17.9429C2.97407 18.1929 3.31321 18.3334 3.66683 18.3334H18.3335C18.6871 18.3334 19.0263 18.1929 19.2763 17.9429C19.5264 17.6928 19.6668 17.3537 19.6668 17.0001V5.00008C19.6668 4.64646 19.5264 4.30732 19.2763 4.05727C19.0263 3.80722 18.6871 3.66675 18.3335 3.66675ZM6.00016 8.33342C5.80238 8.33342 5.60904 8.27477 5.44459 8.16488C5.28014 8.055 5.15197 7.89882 5.07628 7.7161C5.0006 7.53337 4.98079 7.33231 5.01938 7.13832C5.05796 6.94434 5.1532 6.76616 5.29306 6.62631C5.43291 6.48646 5.61109 6.39121 5.80507 6.35263C5.99905 6.31404 6.20012 6.33385 6.38285 6.40954C6.56557 6.48522 6.72175 6.6134 6.83163 6.77784C6.94151 6.94229 7.00016 7.13563 7.00016 7.33341C7.00016 7.59863 6.89481 7.85299 6.70727 8.04052C6.51973 8.22806 6.26538 8.33342 6.00016 8.33342ZM9.3335 8.33342C9.13571 8.33342 8.94238 8.27477 8.77793 8.16488C8.61348 8.055 8.4853 7.89882 8.40962 7.7161C8.33393 7.53337 8.31413 7.33231 8.35271 7.13832C8.3913 6.94434 8.48654 6.76616 8.62639 6.62631C8.76624 6.48646 8.94442 6.39121 9.13841 6.35263C9.33239 6.31404 9.53345 6.33385 9.71618 6.40954C9.89891 6.48522 10.0551 6.6134 10.165 6.77784C10.2748 6.94229 10.3335 7.13563 10.3335 7.33341C10.3335 7.59863 10.2281 7.85299 10.0406 8.04052C9.85307 8.22806 9.59871 8.33342 9.3335 8.33342Z"
        fill="url(#paint0_linear_1097_19232)"
      />
    </g>
    <defs>
      <filter
        id="filter0_iin_1097_19232"
        x="0.333496"
        y="-0.759015"
        width="22.3234"
        height="23.2106"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.136533" dy="0.785067" />
        <feGaussianBlur stdDeviation="2.048" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.152941 0 0 0 0 0.290196 0 0 0 0 0.886275 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1097_19232"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.989867" dy="-1.09227" />
        <feGaussianBlur stdDeviation="1.26635" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.921569 0 0 0 0 0.501961 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_innerShadow_1097_19232"
          result="effect2_innerShadow_1097_19232"
        />
        <feTurbulence
          type="fractalNoise"
          baseFrequency="58.59375 58.59375"
          stitchTiles="stitch"
          numOctaves="3"
          result="noise"
          seed="2877"
        />
        <feColorMatrix in="noise" type="luminanceToAlpha" result="alphaNoise" />
        <feComponentTransfer in="alphaNoise" result="coloredNoise1">
          <feFuncA
            type="discrete"
            tableValues="1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0"
          />
        </feComponentTransfer>
        <feComposite
          operator="in"
          in2="effect2_innerShadow_1097_19232"
          in="coloredNoise1"
          result="noise1Clipped"
        />
        <feFlood floodColor="rgba(255, 235, 128, 0.25)" result="color1Flood" />
        <feComposite
          operator="in"
          in2="noise1Clipped"
          in="color1Flood"
          result="color1"
        />
        <feMerge result="effect3_noise_1097_19232">
          <feMergeNode in="effect2_innerShadow_1097_19232" />
          <feMergeNode in="color1" />
        </feMerge>
      </filter>
      <linearGradient
        id="paint0_linear_1097_19232"
        x1="23.8002"
        y1="1.44275"
        x2="19.0109"
        y2="20.9033"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#274AE2" />
        <stop offset="1" stopColor="#FFEB80" />
      </linearGradient>
    </defs>
  </Svg>
);

export default Page;
